/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {gsap, Linear, TimelineLite} from "gsap";
import {KarenGameAssets} from "../../../KarenGameAssets";
import {KarenLayers, Layers} from "../../../view/KarenLayers";
import {BigWinController} from "./BigWinController";
import {Karen} from "../../../Karen";
import {Translator} from "../../../../core/config/translate/Translator";
import {TranslationTexts} from "../../../../core/config/translate/TranslationTexts";
import {KarenTextStyles} from "../../../KarenTextStyles";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export interface IBitmapFontStyle {
    fontName: string,
    fontSize: number,
    tint: number
}

export class BigWinCountUp extends PIXI.Container {

    protected _countUp: BitmapCountUp;
    private _countUpEffect: PIXI.spine.Spine;
    private _endingScale: number = 0.6;

    constructor() {
        super();

        const style: IBitmapFontStyle = {
            fontName: KarenGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 150,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._waysText = new PIXI.Text("");
        this._waysText.visible = false;
        this._waysText.style = KarenTextStyles.WAYS_TEXT_COUNTUP_STYLE;
        this._waysText.position = new PIXI.Point(10, 100);
        this._waysText.anchor.set(0.5, 0.5);
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this._countUpEffect = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset("countUpEffect"));
        this.addChild(this._countUpEffect, this._countUp, this._waysText);
        this.position.set(360, 510);
        KarenLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    protected _waysText: PIXI.Text;

    public set waysText(value: number) {
        this._waysText.text = value.toString() + " " + Translator.translate((value == 1 ? TranslationTexts.WAY_WON : TranslationTexts.WAYS_WON));
        this._waysText.y = 100;
        this._waysText.updateTransform();
    }

    public getCountUpAnimation(from: number, to: number, duration: number): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power3.out`)
        ]);
        return tl;
    }

    public stay(): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        tl.add([
            gsap.to(this._countUp.scale, {
                duration: 0.5,
                x: this._endingScale,
                y: this._endingScale,
                ease: `elastic.out(1, 1)`
            }),
            gsap.fromTo(this.position, {}, {
                duration: 0.2,
                x: 360,
                y: 360,
                ease: Linear.easeInOut
            })
        ]);
        tl.add(() => {
            this._waysText.visible = true;
            this._waysText.alpha = 1;
        });
        return tl;
    }

    public remove(): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        if (this._countUp.visible) {
            Karen.bigWinController._view.remove();
            tl.add(gsap.to(this._countUp, {
                duration: 0.5,
                alpha: 0,
                //y: NolimitApplication.screenBounds.height,
                ease: `power2.in`
            }), `+=0.2`); // stay a short while after count up
            tl.add(gsap.to(this._waysText, {
                duration: 0.35,
                alpha: 0,
                //y: NolimitApplication.screenBounds.height - 200,
                ease: `power2.in`
            }), `-=0.4`); // stay a short while after count up.
            tl.add(() => {
                this._waysText.visible = false;
                this._countUp.visible = false;
                this._countUp.y = 0;
                this.position.set(360, 510);
            });
        }
        return tl;
    }

    public setCountUpEffects(anim: string = "large"): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._countUpEffect.state.setAnimation(0, anim, false);
        });
        return tl;
    }
}
